import React, { useRef } from "react";
import { herobg, border, arrow1, factionbg } from "../Assets";
import { Chosen, Factions, Mint, Navbar, World } from "../Components";
import Roadmap from "../Components/Roadmap";
import WhitelistChecker from "../Components/WhitelistChecker";
import NavbarChecker from "../Components/NavbarChecker";

const Checker = () => {
  const chosenRef = useRef(null);
  const worldRef = useRef(null);
  const factionRef = useRef(null);
  const mintRef = useRef(null);
  const roadmapRef = useRef(null);
  const whitelistRef = useRef(null)

  const scrollToSection = (ref) => {
    console.log("ref", ref)
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="w-full">
      <section
        className="relative min-h-screen bg-cover bg-center px-4 md:px-10 py-10"
        style={{ backgroundImage: `url(${herobg})` }}
      >
        <div
          className="absolute inset-0 z-0 w-full h-full bg-no-repeat bg-center rounded-[8px]"
          style={{
            backgroundImage: window.innerWidth >= 1024 ? `url(${border})` : "none",
            backgroundSize: "100% 100%",
            transform: "scale(0.9)",
            transformOrigin: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />

        <div className="relative z-10 m-4 p-4 rounded-tl-3xl rounded-br-3xl h-full">
          <NavbarChecker 
          chosenRef={chosenRef} 
          worldRef={worldRef} 
          factionRef={factionRef} 
          mintRef={mintRef} 
          roadmapRef={roadmapRef} 
          whitelistRef={whitelistRef} 
          
          />
          <div className="flex flex-col justify-end items-start  h-full text-white text-left min-h-[60vh] max-w-6xl mx-auto px-6">
        <WhitelistChecker />
          
          </div>
          {/* <button
            onClick={() => {
              const el = document.getElementById("whitelist");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-white text-sm mx-auto flex flex-col items-center justify-center mt-10 md:mt-6"
          >
            <p className="uppercase">scroll down</p>
            <img src={arrow1} alt="Scroll down" className="w-6 h-6 mt-1" />
          </button> */}
        </div>
      </section>

  

      {/* <section id="world" ref={worldRef}>
        <World />
      </section>

      <section id="chosen" ref={chosenRef}>
        <Chosen />
      </section>

      <div
        className="w-full bg-cover bg-center bg-no-repeat py-8 px-4"
        style={{ backgroundImage: `url(${factionbg})` }}
      >
        <section id="factions" className="hidden lg:block" ref={factionRef}>
          <Factions />
        </section>

        <section id="mint" ref={mintRef}>
          <Mint />
        </section>
      </div>

      <section id="roadmap" ref={roadmapRef}>
        <Roadmap />
      </section> */}
  
    </div>
  );
};

export default Checker;
